import { formatDateTime, normalizeTime, systemUses24HourTime } from '@app/utils'
import { useCallback } from 'react'

export interface UserPreferences {
	getUserPreferredTime: (date: Date | string | number) => string
}
export function useUserPreferences() {
	const getUserPreferredTime = useCallback((date: Date | string | number) => {
		const dt = normalizeTime(date)
		const format = systemUses24HourTime() ? 'hh:nn' : 'HH:nn AM'
		return formatDateTime(dt, format)
	}, [])

	return { getUserPreferredTime }
}
